<template>
  <kds2-pop kind="rest" role="listbox" :anchor="anchor" :label="tx('rest.label')" @close="$emit('close')">
    <button
      v-for="o in options"
      :key="o.id"
      type="button"
      role="option"
      class="k2-opt"
      :class="{ on: String(value) === String(o.id) }"
      :aria-selected="String(value) === String(o.id) ? 'true' : 'false'"
      :data-fk="'ro-' + o.id"
      @click="$emit('pick', o.id)"
    >
      <k2-icon n="mdi-storefront-outline" :s="20" />
      <span>{{ o.name }}</span>
      <i class="n">{{ o.count }}</i>
      <k2-icon v-if="String(value) === String(o.id)" n="mdi-check" :s="20" />
    </button>
  </kds2-pop>
</template>

<script>
import K2Icon from "./K2Icon.vue";
import Kds2Pop from "./Kds2Pop.vue";
import kds2Text from "@/mixins/kds2Text";

// Administrator: svi restorani ili jedan (sa brojem narudžbi).
export default {
  name: "Kds2RestPop",
  components: { K2Icon, Kds2Pop },
  mixins: [kds2Text],
  props: {
    anchor: { default: null },
    value: { type: [String, Number], default: "" },
    list: { type: Array, required: true }, // [{ id, name, count }]
    total: { type: Number, default: 0 },
  },
  computed: {
    options() {
      return [{ id: "", name: this.tx("rest.all"), count: this.total }].concat(this.list);
    },
  },
};
</script>
